import React from 'react'
import { withRouter } from 'react-router-dom'
// import AssetsLiabilities from '../assets-liabilities/AssetsLiabilities'
import Files from '../file/Files'

function Home() {
  return <Files />
}
export default withRouter(Home)
